import { getPlural } from '@js-dot/text';
const EnglishPluralExpression = {
  pattern: /^s$/,
  transform(word, [_, amount], values) {
    return getPlural(word, values);
  }
};

/**
 * Generated bundle index. Do not edit.
 */

export { EnglishPluralExpression };
